/** Chuyển camelCase sang kebab-case (một cụm từ, không split số). */
const toKebab = (segment: string): string =>
  segment.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()

/** Tham chiếu `--ui-*-*` đồng bộ bởi `syncPaletteToCssVars` */
export const cv = (...pathSegments: string[]): string =>
  `var(--ui-${pathSegments.map(toKebab).join('-')})`

const walkLeaves = (
  obj: Record<string, unknown>,
  prefix: string[],
  setVar: (name: string, value: string) => void,
): void => {
  for (const key of Object.keys(obj)) {
    const val = obj[key]
    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
      walkLeaves(val as Record<string, unknown>, [...prefix, key], setVar)
    } else if (typeof val === 'string') {
      const cssName = [...prefix, key].map(toKebab).join('-')
      setVar(cssName, val)
    }
  }
}

export const syncPaletteToCssVars = (palette: Record<string, unknown>): void => {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  walkLeaves(palette, [], (suffix, val) => {
    root.style.setProperty(`--ui-${suffix}`, val)
  })
}
